// src/pages/PhotoPage.js
// Функция для динамического импорта всех изображений из папки
const importAll = (r) => {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
};

// Автоматически подхватываем все файлы из папки gallery
const images = importAll(require.context('../assets/gallery', false, /\.(png|jpe?g|gif|webp)$/));

const PhotoPage = () => {
  // Преобразуем объект в массив ссылок
  const photoList = Object.values(images);

  return (
    <div className="container page-container">
      <div className="page-kicker"><p className="eyebrow"><span /> из жизни центра</p></div>
      <h1 className="page-title">Фотографии<br /><em>с характером.</em></h1>
      {photoList.length === 0 ? (
        <p className="text-center text-gray-500">Фотографии отсутствуют</p>
      ) : (
        <div className="gallery-grid">
          {photoList.map((src, idx) => (
            <div key={idx} className={`gallery-item gallery-item--${idx % 5}`}>
              <img
                src={src}
                alt={`Фото ${idx + 1}`}
                className="gallery-image"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoPage;
